import { Link } from "react-router-dom";
import { Heart, X } from "lucide-react";
import { thumbUrl } from "@/lib/api";
import { useFavorites } from "@/components/FavoriteButton";

export const FavoritesGrid = () => {
  const { designs, toggle } = useFavorites();
  return (
    <section data-testid="favorites-section">
      <h2 className="font-display text-xl font-bold text-white mt-10 mb-4 flex items-center gap-2"><Heart size={18} className="text-[#ff4d6d]" fill="currentColor" />Favorites</h2>
      {designs.length === 0 ? (
        <div className="bg-[#12141a] border border-zinc-800 rounded-2xl p-8 text-center" data-testid="favorites-empty">
          <p className="text-zinc-400 text-sm">No favorites yet. Tap the heart on any design in the catalog to save it here.</p>
          <Link to="/catalog" className="inline-block mt-3 text-[#ff6a13] font-semibold text-sm">Browse designs →</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {designs.map((d) => (
            <div key={d.design_id} className="relative bg-[#12141a] border border-zinc-800 rounded-2xl overflow-hidden group" data-testid={`favorite-card-${d.design_id}`}>
              <button onClick={() => toggle(d.design_id)} aria-label="Remove from favorites" data-testid={`favorite-remove-${d.design_id}`}
                className="absolute top-2 right-2 z-10 rounded-full bg-black/60 border border-white/10 p-1.5 text-zinc-300 hover:text-white hover:bg-red-500/70 transition-colors"><X size={13} /></button>
              <Link to={`/catalog/${d.design_id}`} className="block">
                <div className="checker aspect-square flex items-center justify-center p-4">
                  <img src={thumbUrl(d.image_url, 480)} alt={d.title} loading="lazy" className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform" />
                </div>
                <div className="p-3">
                  <h3 className="font-semibold text-white text-sm truncate">{d.title}</h3>
                  <div className="flex items-center justify-between mt-1">
                    <span className="text-xs text-zinc-500 font-mono-p">from ${(d.base_price || 0).toFixed(2)}</span>
                    <span className="text-xs text-[#ff6a13] font-semibold">Customize →</span>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
